import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global 401 handler: on expired/invalid session, redirect to the correct
// login portal instead of surfacing raw backend error strings.
const AUTH_ENDPOINTS = ["/auth/login", "/auth/me", "/tenant-auth/login", "/tenant-auth/me", "/tenant/auth/login", "/tenant/auth/me", "/landlord/auth/login", "/landlord/auth/me"];
let redirecting = false;

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const isAuthEndpoint = AUTH_ENDPOINTS.some((e) => url.includes(e));
    if (status === 401 && !isAuthEndpoint && !redirecting) {
      const path = window.location.pathname;
      const isTenant = path === "/tenant" || path.startsWith("/tenant/");
      const isLandlord = path === "/landlord" || path.startsWith("/landlord/");
      const target = isLandlord ? "/landlord/login" : isTenant ? "/tenant/login" : "/login";
      if (path !== target) {
        redirecting = true;
        window.location.assign(target);
      }
      error.__handledAuth = true;
    }
    return Promise.reject(error);
  }
);

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "エラーが発生しました。もう一度お試しください。";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
